export function generateRowSummary(
  items: readonly unknown[],
  hasCoupon: boolean
) {
  return `${items.length} item${items.length > 1 ? 's' : ''}${
    hasCoupon ? ', coupon code applied' : ''
  }`
}
